exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".multiselect__option--highlight{background:#1de9b6!important}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/combo/GroupForm.vue"],"names":[],"mappings":"AACA,gCACE,4BAA+B,CAChC","file":"GroupForm.vue","sourcesContent":["\n.multiselect__option--highlight {\n  background: #1DE9B6 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-070a008c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=3!./src/views/admin/combo/GroupForm.vue
// module id = 1633
// module chunks = 0